import { render } from "./MypageCommunityList.vue?vue&type=template&id=3a651b21&scoped=true"
import script from "./MypageCommunityList.vue?vue&type=script&lang=js"
export * from "./MypageCommunityList.vue?vue&type=script&lang=js"

import "./MypageCommunityList.vue?vue&type=style&index=0&id=3a651b21&lang=scss&scoped=true"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a651b21"]])

export default __exports__